// createSamplingEvent/state.js

export const createSamplingEventUIInitialState = {
  // Well cards pagination
  currentWellPage: 1,
  wellsPerPage: 10,

  // Well cards filtering and sorting
  wellFilters: {
    wellId: "",
    wellPurpose: "",
    status: "",
    groupAssignment: "all", // 'all', 'assigned', or 'unassigned'
  },
  wellSort: {
    field: "well_id",
    direction: "asc", // 'asc' or 'desc'
  },
  isFilterMenuOpen: false,
};

export const createSamplingEventInitialState = {
  // Event Information
  eventName: "",
  startDate: null,
  endDate: null,
  teamLead: null,

  // Project Information
  noProjectNumberChecked: false,
  selectedProject: null,
  selectedPhase: null,
  selectedTask: null,
  projectDescription: "",
  availablePhases: [],
  availableTasks: [],

  // Site and Well Information
  newSelectedSamplingSite: null,
  selectedSiteWellInfo: null,
  selectedWellIds: [],

  // Group Information
  samplingGroups: [],
  nextGroupId: 1,

  // Equipment & ancillary
  samplingEquipmentMeters: [],

  // Pagination for events list is elsewhere; this is form-only state

  // Form validation
  formErrors: {},
};
